module.exports = __webpack_public_path__ + "img/database.fc71243e.svg";